// eslint-disable-next-line import/prefer-default-export
export const setUserData = (userData) => ({
  type: 'SET_USER_DATA',
  payload: userData,
});
